import styled from 'styled-components'
import { linkStyle } from '@berlitz/link'
import { RichText } from '@berlitz/globals'

export const PhoneNumber = styled.a`
  ${linkStyle}
  display: inline-flex;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
`

export const NumbersList = styled.ul`
  align-items: center;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    columns: 1;
    padding-bottom: 0;
  }
`

export const NumberItem = styled.li`
  text-align: center;
  break-inside: avoid;
  padding: ${({ theme }) => theme.space.sm};
  &:nth-child(odd) {
    background-color: ${({ theme }) => theme.palette.blue10};
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme }) => theme.space.md};
  }
`
export const RichTextStyled = styled(RichText)`
  &[data-key='max-rich-text'] * {
    padding-bottom: 0;
    font-size: ${({ theme }) => theme.fontSize.xxs};
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      font-size: ${({ theme }) => theme.fontSize.xxs};
    }
  }
`
